import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import { ModelType } from '/@/modules/core/app/constants/ModelType';
import { Address } from '@/modules/address/models/Address';
import { CourthouseHearing } from '@/modules/courthouse/models/CourthouseHearing';
import { MailNotification } from '@/modules/notification/models/MailNotification';

export class Courthouse extends BaseEntityModel {
  id?: number;
  name?: string;
  branchName?: string;
  estateId?: number;
  probateFormsRequireWetSignature: boolean | null;
  probateFormsRequireManualFiling: boolean | null;
  probateFilingProcessConfirmed: boolean | null;
  address?: Relationship<Address> | null;
  courthouseHearing: Relationship<CourthouseHearing> | null;
  mailNotification: Relationship<MailNotification> | null;

  constructor(model: Partial<Courthouse> = {}) {
    super(model);
    this.id = model.id;
    this.name = model.name;
    this.branchName = model.branchName;
    this.estateId = model.estateId;
    this.probateFormsRequireWetSignature = model.probateFormsRequireWetSignature ?? null;
    this.probateFormsRequireManualFiling = model.probateFormsRequireManualFiling ?? null;
    this.probateFilingProcessConfirmed = model.probateFilingProcessConfirmed ?? null;

    this.address = Address.mapModelOrNull(model.address);
    this.courthouseHearing = CourthouseHearing.mapModelOrNull(model.courthouseHearing);
    this.mailNotification = MailNotification.mapModelOrNull(model.mailNotification);
  }

  getModelName(): ModelType {
    return ModelType.COURTHOUSE;
  }
}
